import { subMonths } from 'date-fns/subMonths';

import { BotcoAPI } from '@botco/api';
import { constants } from '~/config';
import { handleErrors } from '~/utils';
import Api from '~/utils/http';

import {
  ALL_INTENTS,
  SET_SELECTED_AGENT,
  CURRENT_AGENT_DETAILS,
  SET_TRAINING_LOADER,
  SET_TRAINING_SESSIONS_LOADER,
  GET_DEPLOYMENTS,
  TRAINING_UTTERANCES_NOT_FOUND,
  TRAINING_UTTERANCES,
  TRAINING_SESSION_DATA_NOT_FOUND,
  TRAINING_SESSION_DATA,
  SET_DEPLOYMENTS_LOADER,
  CREATE_INTENT,
  CREATE_INTENT_INPUT,
} from '../types/conversationNew';

const newApiCall = new BotcoAPI(constants.api_url);

export const getIntentsByAgentId = (agent_id) => {
  if (!agent_id) return { type: ALL_INTENTS, payload: [] };
  return async (dispatch) => {
    try {
      const { data } = await newApiCall.getIntents(agent_id);
      return dispatch({ type: ALL_INTENTS, payload: data });
    } catch (error) {
      return dispatch({ type: ALL_INTENTS, payload: [] });
    }
  };
};

export const getAgentDetails = (agent_id) => {
  return (dispatch) => {
    newApiCall
      .getAgent(agent_id)
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        return dispatch({
          type: CURRENT_AGENT_DETAILS,
          payload: response.data,
        });
      })
      .catch((error) => handleErrors(error, 'Could not get agent details.'));
  };
};

///---- training ----///

export const setDeploymentsLoader = (status) => {
  return {
    type: SET_DEPLOYMENTS_LOADER,
    status,
  };
};

export const setTrainingLoader = (status) => {
  return {
    type: SET_TRAINING_LOADER,
    status,
  };
};

export const setTrainingDetailsLoader = (status) => {
  return {
    type: SET_TRAINING_SESSIONS_LOADER,
    status,
  };
};

//get deplyments for training
export const getAllDeployments = () => async (dispatch) => {
  dispatch(setDeploymentsLoader(true));
  try {
    const { data } = await newApiCall.getDeployments();
    dispatch(setDeploymentsLoader(false));
    return dispatch({
      type: GET_DEPLOYMENTS,
      payload: data,
    });
  } catch (error) {
    handleErrors(error, 'Failed to fetch deployed details');
  }
};

//get all training chat utterances
export const getAllTrainingUtterances = (
  { agent_id, deploy_id },
  page = 0,
  size = 10,
  startDate = null
) => {
  let start_time = startDate;
  if (!start_time)
    start_time = `${subMonths(new Date(), 12).toISOString().split('.')[0]}Z`;

  const reqObj = { start_time, agent_id, deploy_id, page, size, confidence: 1 };
  return (dispatch) => {
    if (agent_id === -1) {
      return dispatch({
        type: TRAINING_UTTERANCES,
        payload: {
          content: [],
          number: 0,
          totalPages: 0,
          empty: true,
          size: 0,
        },
      });
    }
    dispatch(setTrainingLoader(true));
    Api.training
      .getTrainings(reqObj)
      .then((response) => {
        if (response.status === 400) {
          return dispatch({
            type: TRAINING_UTTERANCES_NOT_FOUND,
          });
        }
        if (response.status > 400) {
          const err = { response };
          handleErrors(err);
          return;
        }
        if (response.status === 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        dispatch(setTrainingLoader(false));
        return dispatch({
          type: TRAINING_UTTERANCES,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch(setTrainingLoader(false));
        if (err.response.status === 400) {
          return dispatch({
            type: TRAINING_UTTERANCES_NOT_FOUND,
          });
        }
        handleErrors(err, 'Failed to fetch training utterances');
      });
  };
};

//get asingle training session
export const getTrainingSessionDetails = (sessionId) => {
  const reqObj = { sessionId, confidence: 1 };
  return (dispatch) => {
    dispatch(setTrainingDetailsLoader(true));
    newApiCall
      .getSingleTrainingUtterance(reqObj)
      .then((response) => {
        if (response.status === 400) {
          return dispatch({
            type: TRAINING_SESSION_DATA_NOT_FOUND,
          });
        }
        if (response.status === 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        if (response.status > 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        dispatch(setTrainingDetailsLoader(false));
        return dispatch({
          type: TRAINING_SESSION_DATA,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch(setTrainingDetailsLoader(false));
        if (err.response !== undefined && err.response.status === 400) {
          return dispatch({
            type: TRAINING_SESSION_DATA_NOT_FOUND,
          });
        }
        handleErrors(err, 'Failed to fetch training session data');
      });
  };
};

//create Intent
export const createIntent = (agent_id, intent_name, userMessage) => {
  const reqObj = { agent_id, intent_name };
  return (dispatch) => {
    newApiCall
      .addIntent(reqObj)
      .then((response) => {
        if (response.status === 400) {
          return;
        }
        if (response.status === 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        if (response.status > 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        if (userMessage !== undefined)
          dispatch(
            createIntentInputTranscript(userMessage, { ...response.data })
          );
        return dispatch({
          type: CREATE_INTENT,
          payload: response.data,
        });
      })
      .catch((err) => {
        handleErrors(err, 'Failed to create intent');
      });
  };
};

//create Intent input
export const createIntentInputTranscript = ({
  agent_id,
  input_value,
  intent,
  deploy_id,
  training_log_id,
}) => {
  return (dispatch) => {
    return newApiCall
      .createIntentInputTranscript({
        agent_id,
        input_value,
        intent_id: intent.id,
        deploy_id,
        training_log_id,
      })
      .then((response) => {
        if (response.status === 400) {
          return;
        }
        if (response.status === 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        if (response.status > 401) {
          const err = { response };
          handleErrors(err);
          return;
        }
        return dispatch({
          type: CREATE_INTENT_INPUT,
          payload: response.data,
          intent: intent,
        });
      })
      .catch((err) => {
        handleErrors(err, 'Failed to create intent input');
      });
  };
};

export const setSelectedAgent = (agent) => {
  return {
    type: SET_SELECTED_AGENT,
    payload: agent,
  };
};
